import { tickets } from '../services/ApiService';
import { ticketsConstants } from '../constants/tickets';

export const setTickets = (tickets = [], total = 0) => ({
  type: ticketsConstants.SET_TICKETS_SUCCESS,
  total: total,
  tickets,
});

export const startSetTickets = (params) => (dispatch) => {
  return tickets
    .getList(params)
    .then((data = {}) => dispatch(setTickets(data.items, data.total)))
    .catch((err) => dispatch({ type: ticketsConstants.SET_TICKETS_FAILURE }));
};

export const setTicket = (ticket = {}, additions = []) => ({
  type: ticketsConstants.SET_TICKET_SUCCESS,
  ticket,
  additions,
});

export const startSetTicket = (ticketId) => (dispatch) => {
  return tickets
    .getTicket(ticketId)
    .then((data = { items: [] }) => dispatch(setTicket(data.items[0], data.additions)));
};

export const startCloseTicket = (ticketId) => (dispatch) => {
  return tickets
    .closeTicket(ticketId)
    .then(() => dispatch({ type: ticketsConstants.CLOSE_TICKET_SUCCESS }))
    .catch((err) => dispatch({ type: ticketsConstants.CLOSE_TICKET_FAILURE }));
};

export const startCreateTicket =
  (ticketData = {}) =>
  (dispatch) => {
    return tickets.create(ticketData).then((data = {}) => {
      dispatch({ type: ticketsConstants.CREATE_TICKET_SUCCESS });
      return data.items;
    });
    // ОБРАБАТЫВАЕТСЯ САБМИТАМИ В ФОРМАХ ВО ВЬЮХЕ
    // .catch(err => dispatch({ type: ticketsConstants.CREATE_TICKET_FAILURE }));
  };

export const startAddReplyTicket =
  (ticketId, ticketData = {}) =>
  (dispatch) => {
    return tickets.sendReply(ticketId, ticketData).then((data = {}) => {
      dispatch({ type: ticketsConstants.ADD_REPLY_TICKET_SUCCESS });
      return data.items;
    });
    // ОБРАБАТЫВАЕТСЯ САБМИТАМИ В ФОРМАХ ВО ВЬЮХЕ
    // .catch(err => dispatch({ type: ticketsConstants.ADD_REPLY_TICKET_FAILURE }));
  };

export const startSetTicketRating = (params) => (dispatch) => {
  return tickets
    .setTicketRating(params)
    .then(() => dispatch({ type: ticketsConstants.SET_RATING_TICKET_SUCCESS }))
    .catch((err) => dispatch({ type: ticketsConstants.SET_RATING_TICKET_FAILURE }));
};

export const startSetTicketHelp = (params) => (dispatch) => {
  return tickets
    .setTicketHelp(params)
    .then(() => dispatch({ type: ticketsConstants.SET_HELP_TICKET_SUCCESS }))
    .catch((err) => dispatch({ type: ticketsConstants.SET_HELP_TICKET_FAILURE }));
};

export const markTicketAsRead = (ticketId) => ({
  type: ticketsConstants.MARK_TICKET_AS_READ,
  ticketId,
});
